import { Typography, Link, Button, ButtonStyles } from '@grammarly/badger-ui'
import { withPublicAssetUrl } from '../../lib/utils/cdn'
import styles from './error-boundary.module.scss'
import { getConfig } from '../../config'

const { T1, C1, C2 } = Typography
const robot = withPublicAssetUrl('error/robot@2x.gif')
const supportNewRequestUrl = getConfig().support.urls.newRequest

interface ErrorFallbackProps {
  resetError: () => void
}

export const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  return (
    <main className={styles.container}>
      <img src={robot} width={155} height={215} alt="" />
      <T1 as="h1">Our AI-powered robots are recharging.</T1>
      <C1 as="p">
        Grammarly is currently unavailable while we make upgrades
        <br />
        to improve the service for you. Please try again in a minute.
      </C1>
      <Button className={ButtonStyles.GreenButtonWhiteText} onClick={resetError}>
        Try again?
      </Button>
      <C2 as="p">
        We apologize for the inconvenience and appreciate your patience.
        <br />
        For more information, please <Link href={supportNewRequestUrl}>contact support</Link>.
      </C2>
    </main>
  )
}
